import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/NavSeasonalFlyoutMerchants';

export const NAV_SEASONAL_FLYOUT_PLACEMENTS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const NAV_SEASONAL_FLYOUT_PLACEMENTS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
